import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

export class CustomersRequests {

  /* @ngInject */
  constructor(private customersAPI: BringozApi, private $customers) {
  }

  createCustomer(data) {
    const api = this.customersAPI.actions.createCustomer;
    return this.$$call(api, {}, data, {});
  }

  deleteCustomer(customerId, shouldMask) {
    const api = this.customersAPI.actions.deleteCustomer;
    return this.$$call(api, {mask: shouldMask}, {}, {id: customerId});
  }

  updateCustomer(customerId, data) {
    const api = this.customersAPI.actions.editCustomer;
    return this.$$call(api, {}, data, {id: customerId});
  }

  getAddresses(customerId) {
    const api = this.customersAPI.actions.getAddresses;
    return this.$$call(api, {}, {}, {id: customerId});
  }

  addAddress(customerId, address) {
    const api = this.customersAPI.actions.addAddress;
    return this.$$call(api, {}, address, {id: customerId});
  }

  updateAddress(customerId, addressId, address) {
    const api = this.customersAPI.actions.updateAddress;
    return this.$$call(api, {}, address, {id: customerId, addressId: addressId});
  }

  deleteAddress(customerId, addressId) {
    const api = this.customersAPI.actions.deleteAddress;
    return this.$$call(api, {}, {}, {id: customerId, addressId: addressId});
  }

  getDefaultAddress(customerId) {
    const api = this.customersAPI.actions.getDefaultAddress;
    return this.$$call(api, {}, {}, {id: customerId});
  }

  updateDefaultAddress(customerId, addressId) {
    const api = this.customersAPI.actions.updateDefaultAddress;
    return this.$$call(api, {}, {}, {id: customerId, addressId: addressId});
  }

  export(exportType, accountIds) {
    const api = this.customersAPI.actions.export;
    return this.$$call(api, {
      exportType: exportType,
      accountIds: accountIds
    }, {}, {});
  }


  private $$call(_apiCall, _params, _data, _options) {
    return this.$customers().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.customers')
  .service('customersRequests', CustomersRequests);
